<template>
    <div id="csContainer">
      <el-button type="primary" size="small" class="gltf" @click="gltf()">模型加载</el-button>
      <div class="getposition" style="width:220px ">
        <div class="getposition2" v-show="isShow">
          <span >缩放比例:{{scale}}</span>

        <el-slider v-model="scale"  :min="0" :max="10" :step="1"show-input input-size="mini"></el-slider>
         <span >x方向:{{x}}</span>

        <el-slider v-model="x"  :min="-100" :max="100" :step="1"show-input input-size="mini"></el-slider>
         <span >y方向:{{y}}</span>

        <el-slider v-model="y"  :min="-100" :max="100" :step="1"show-input input-size="mini"></el-slider>
         <span >z方向:{{z}}</span>

        <el-slider v-model="z"  :min="-100" :max="100" :step="1"show-input input-size="mini"></el-slider>
        </div>
      </div>
      <div  class="rotate" style="width:220px" v-show="isShow">
        <div class="rotate2">
         <span >X轴旋转(度):{{rx}}</span>
        <el-slider v-model="rx"  :min="-360" :max="360" :step="1"show-input input-size="mini"></el-slider>
        <span >Y轴旋转(度):{{ry}}</span>
        <el-slider v-model="ry" :min="-360" :max="360" :step="1" show-input input-size="mini"></el-slider>
         <span >Z轴旋转(度):{{rz}}</span>
        <el-slider v-model="rz" :min="-360" :max="360" :step="1"  show-input input-size="mini"></el-slider>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"
export default {
    name: "gltf",
    data() {
        return {
          isShow:false,
          modelMatrix:null,
          model:null,
          scale:1.5,
          x: 0.0,
          y: 0.0,
          z: 0.0,
          rx: 0.0,
          ry: 0.0,
          rz: 0.0,
        }
    },
    watch: {
      scale: function (val) {
        // debugger
        this.model.scale = Number(val);
      },
      x: function (a, b) {
        let m = Cesium.Matrix4.fromArray([
          1.0, 0.0, 0.0, 0.0,
          0.0, 1.0, 0.0, 0.0,
          0.0, 0.0, 1.0, 0.0,
          a-b, 0.0, 0.0, 1.0
        ]);
        this.model.modelMatrix =  Cesium.Matrix4.multiply(this.model.modelMatrix, m, m);
      },
      y: function (a, b) {
        let m = Cesium.Matrix4.fromArray([
          1.0, 0.0, 0.0, 0.0,
          0.0, 1.0, 0.0, 0.0,
          0.0, 0.0, 1.0, 0.0,
          0.0, a-b, 0.0, 1.0
        ]);
        this.model.modelMatrix =  Cesium.Matrix4.multiply(this.model.modelMatrix, m, m);
      },
      z: function (a, b) {
        let m = Cesium.Matrix4.fromArray([
          1.0, 0.0, 0.0, 0.0,
          0.0, 1.0, 0.0, 0.0,
          0.0, 0.0, 1.0, 0.0,
          0.0, 0.0, a-b, 1.0
        ]);
        this.model.modelMatrix =  Cesium.Matrix4.multiply(this.model.modelMatrix, m, m);
        // this.model._root.transform = m;
        // this.model.modelMatrix[14] = this.model.modelMatrix[14] + a - b;
      },
      rx: function (newval, oldval) {
        let mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(newval - oldval));
        this.model.modelMatrix = Cesium.Matrix4.multiplyByMatrix3(this.model.modelMatrix, mx, new Cesium.Matrix4());
      },
      ry: function (newval, oldval) {
        let my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(newval - oldval));
        this.model.modelMatrix = Cesium.Matrix4.multiplyByMatrix3(this.model.modelMatrix, my, new Cesium.Matrix4());
      },
      rz: function (newval, oldval) {
        let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(newval - oldval));
        this.model.modelMatrix = Cesium.Matrix4.multiplyByMatrix3(this.model.modelMatrix, mz, new Cesium.Matrix4());
      },
    },
    mounted() {
        this.init();
    },
    methods: {
      init() {
        let vm = new Cesium.Viewer("csContainer", {
          homeButton: false, // 默认相机位置控件
          animation: false, //是否显示动画控件(左下方那个)
          baseLayerPicker: false, //是否显示图层选择控件
          geocoder: false, //是否显示地名查找控件
          timeline: false, //是否显示时间线控件
          sceneModePicker: false, //是否显示投影方式控件
          navigationHelpButton: false, //是否显示帮助信息控件
          infoBox: false, //是否显示点击要素之后显示的信息
        });
        this.viewer = vm;
        this.viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
       this.viewer.camera.setView({
          destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 70.0),
          orientation : {
              heading : Cesium.Math.toRadians(-35),
              pitch : Cesium.Math.toRadians(-95),
              roll : 0.0
          }
      });
      },
      gltf(){
        let viewer = this.viewer;


        this.modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0));

        var ab = Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 70.0)



         this.model = viewer.scene.primitives.add(Cesium.Model.fromGltf({
           name: 'car',
          url : "/demo/static/data/models/car.glb",
           // url : "/demo/static/data/models/xuexiao.gltf",
          // url : 'http://localhost:5000/shanhuasi.gltf',
          // 4x4变换矩阵，用于将模型从模型转换为世界坐标。
          modelMatrix : this.modelMatrix,
          scale : this.scale,
           // colorBlendMode:Cesium.ColorBlendMode['MIX'],

        }));
        // this.model.style = new Cesium.Cesium3DTileStyle({
        //   color : 'color("purple", 0.8)',
        // });
        // let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        // handler.setInputAction(function (movement) {
        //   var pickedObject = viewer.scene.pick(movement.endPosition);
        //   if(Cesium.defined(pickedObject)&&(pickedObject.id === this.model)){
        //     this.model.scale = 3;
        //   }else{
        //     // entity.billboard.scale = 1.0;
        //     // entity.billboard.color = Cesium.Color.WHITE;
        //   }
        // },Cesium.ScreenSpaceEventType.MOUSE_MOVE);

        viewer.camera.setView({
          destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 70.0),
          orientation : {
            heading : Cesium.Math.toRadians(-35),
            pitch : Cesium.Math.toRadians(-95),
            roll : 0.0
          }
        });
        this.isShow = true;
        // let self = this;
        // self.model.readyPromise.then(function (){
        //   let ab = this.model.boundingSphere;
        //
        //   ab.center = Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0);
        //
        //   viewer.camera.viewBoundingSphere(ab,
        //           new Cesium.HeadingPitchRange(-0.1, -0.2, ab.radius));
        //
        // });
        // model.readyPromise.then(function (t) {
        //   viewer.camera.setView({
        //     destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 70.0),
        //     // orientation : {
        //     //   heading : Cesium.Math.toRadians(-35),
        //     //   pitch : Cesium.Math.toRadians(-95),
        //     //   roll : 0.0
        //     // }
        //   });
        // });
      },
    },
  }
</script>

<style scoped>
  .gltf {
    position: absolute;
    margin-top: 7px;
    margin-left: 25px;
    z-index: 110;
  }
  .getposition{
    font-size: 5px;
    position: absolute;
    margin-top: 200px;
    /*margin-left: 800px;*/
      right: 10px;
    z-index: 110;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .getposition2{
    margin: 10px !important;
    color:white !important;
  }
  .rotate{
    font-size: 5px;

    position: absolute;
     /*width:230px;*/
    margin-top: 7px;
    /*margin-left: 1028px;*/
    right: 10px;
    z-index: 110;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .rotate2{
    margin: 10px !important;
    color:white !important;
  }

  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
